import { useTranslation } from 'react-i18next';
import ExclusiveTypeIcon, {
  ExclusiveType,
} from '../../../../SoldExclusivesSection/ExclusiveTypeIcon/ExclusiveTypeIcon';

import s from './SoldExclusivesTableRowHeadingMobile.scss';

interface Props {
  item: any;
}

export default function SoldExclusivesTableRowHeadingMobile({ item }: Props) {
  const exclusiveType = item.exclusiveType as ExclusiveType;
  const { t } = useTranslation();

  return (
    <div className={s['row-heading']}>
      <ExclusiveTypeIcon exclusiveType={exclusiveType} size={32} />
      <div className={s['type-label']}>
        {t(`studio.reports.section.soldExclusives.types.${exclusiveType}`)}
      </div>
    </div>
  );
}
